import React, { useEffect } from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Badge } from "@mui/material";
import { fetchOnlyData } from "../../utility/managerApi";
import { useQuery } from "@tanstack/react-query";

function Notification({ toggleNotification, setNotifications }) {
  const {
    data: notifications,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["notifications"],
    keepPreviousData: true,
    queryFn: () => fetchOnlyData("notifications"),
    staleTime: 4000,
    // Keep previous data during page changes
  });

  useEffect(() => {
    if (notifications && Array.isArray(notifications)) {
      setNotifications(notifications);
    }
  }, [notifications]);

  const totalUnread = Array.isArray(notifications)
    ? notifications.filter((item) => item?.read == 0).length
    : 0;

  return (
    <>
      <button onClick={toggleNotification}>
        <Badge color="secondary" badgeContent={totalUnread}>
          <NotificationsIcon className="text" sx={{ fontSize: 40 }} />{" "}
        </Badge>
      </button>
    </>
  );
}

export default Notification;
